import React, { useState } from 'react';
import { Form, useNavigate } from 'react-router-dom';

//Header Data
import headerLogo from '../assets/desall_logo.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';

//Assets
import creative from '../assets/creative_placeholder.png';
import footerImg from '../assets/footer_placeholder_transparent.png';

//Components
import AppFooter from '../components/AppFooter/AppFooter';
import axiosHelper from '../helpers/axiosHelper';
import { useStoreState } from 'pullstate';
import { getFooterMenu, getHeaderMenu } from '../store/Selectors';
import { LoginSocialGoogle, LoginSocialFacebook, IResolveParams } from 'reactjs-social-login';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../context/AuthContext';
import { ROUTEPATHS } from './routePaths';
import { useBanner } from '../context/BannerContext';
import DslStore from '../store/DslStore';
import AppHeaderWLF from '../components/AppHeader/AppHeaderWLF';
import { set, useForm } from 'react-hook-form';
import { LoginForm } from '../global';
import FormField from '../components/Forms/FormField';
import ErrorBlock from '../components/Forms/ErrorBlock';

const LoginPage: React.FC = () => {
  const { createAndAddBannerMessage } = useBanner();
  const { login, ggLogin, fbLogin, twLogin, lkLogin } = useAuth();
  const [sentReset, setSentReset] = useState(false);
  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);
  const navigate = useNavigate();
  const [error, setError] = useState<string | undefined>();

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<LoginForm>({ mode: 'onBlur', reValidateMode: 'onBlur' });

  const form2 = useForm<LoginForm>({ mode: 'onBlur', reValidateMode: 'onBlur' });

  const resetPassword = async (df: LoginForm) => {
    await axiosHelper
      .resetPassword(df.email)
      .then((response) => {
        console.log(response);
        setSentReset(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onSubmit = async (fd: LoginForm) => {
    console.log(fd);
    setError(undefined);
    login(fd.email, fd.pwd, fd.rememberMe)
      .then((data) => {
        if (data) {
          createAndAddBannerMessage('Welcome to Desall!', 'success', 'welcomeMessage');
          if (data.userType === 'G') {
            navigate(`/`);
          } else {
            navigate(`/${ROUTEPATHS.COMMUNITY}/${data.nameForURL}/profile-editable`);
          }
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('Wrong username or password');
      });
  };

  // const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   if (!email || !password) {
  //     setError('Username (or email) and password are required');
  //     return;
  //   }
  //   setError('');
  //   login(email, password, rememberMe)
  //     .then((data) => {
  //       if (data) {
  //         createAndAddBannerMessage('Welcome to Desall!', 'success', 'welcomeMessage');
  //         if (data.userType === 'G') {
  //           navigate(`/`);
  //         } else {
  //           navigate(`/${ROUTEPATHS.COMMUNITY}/${data.nameForURL}/profile-editable`);
  //         }
  //       } else {
  //         setError('Unknown error');
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setError('Wrong username or password');
  //     });
  // };

  const googleLogin = async (token: string, uid: string, email: string) => {
    setError('');
    ggLogin(email, token, uid)
      .then((data) => {
        if (data) {
          createAndAddBannerMessage('Welcome to Desall!', 'success', 'welcomeMessage');
          navigate(`/${ROUTEPATHS.COMMUNITY}/${data.nameForURL}/profile-editable`);
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('User not found');
      });
  };

  const facebookLogin = async (token: string, uid: string, email: string) => {
    setError('');
    fbLogin(email, token, uid)
      .then((data) => {
        if (data) {
          createAndAddBannerMessage('Welcome to Desall!', 'success', 'welcomeMessage');
          navigate(`/${ROUTEPATHS.COMMUNITY}/${data.nameForURL}/profile-editable`);
        } else {
          setError('Unknown error');
        }
      })
      .catch((e) => {
        console.log(e);
        setError('User not found');
      });
  };

  return (
    <>
      <AppHeaderWLF links={headerMenu} bgColor="#7997c5" logoImg={headerLogo} bgImage={creative} pageTitle="Login" hideSearch={true} />
      <main className="container-fluid py-5 bg-light-gray">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row justify-content-center">
            <div className="col-12 col-md-4 col-lg-3">
              <div className="row">
                <div className="col-12 text-center">
                  <h1 className="sub-title color-dark my-5">Login</h1>
                </div>
              </div>
              <div className="row">
                <FormField name="email" label="Username or E-mail" fullWidth required error={errors.email}>
                  <input id="email" type="text" placeholder="username or e-mail" className="text-center" autoComplete="username" {...register('email', { required: 'Please insert username or email' })} />
                </FormField>
              </div>
              <div className="row ">
                <FormField name="pwd" label="Password" fullWidth required error={errors.pwd}>
                  <input id="pwd" type="password" placeholder="password" className="text-center" autoComplete="current-password" {...register('pwd', { required: 'Please insert password' })} />
                </FormField>
              </div>
              <div className="row ">
                <FormField name="rememberMe" fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-1" className="" {...register('rememberMe')} />
                    <label htmlFor="checkbox-1" className="d-block text-start ps-4 py-2 text">
                      Remember me
                    </label>
                  </div>
                </FormField>
              </div>
            </div>
          </div>
          <ErrorBlock error={error ? { message: error } : undefined} />

          <div className="row justify-content-center">
            <div className="col-12 col-md-3 col-lg-3 mb-5">
              <button type="submit" className="btn-dark-blue full rounded 3">
                login
              </button>
            </div>
          </div>
        </form>
        <div className="row text-center justify-content-center">
          <div className="col-12 col-md-4 col-lg-3">
            <h1 className="sub-title color-dark mb-5">or connect with</h1>
            <LoginSocialGoogle
              client_id={process.env.REACT_APP_GG_APP_ID || ''}
              scope="openid profile email"
              redirect_uri={process.env.REACT_APP_SOCIAL_LOGIN_ENDPOINT || ''}
              onReject={() => console.log('error')}
              onResolve={({ provider, data }: IResolveParams) => {
                console.log(provider);
                console.log(data);
                googleLogin(data?.access_token, data?.sub, data?.email);
              }}
            >
              <button className="btn-social__google full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faGoogle as IconProp} className="text color-light" />
                </div>
                google
              </button>
            </LoginSocialGoogle>

            <LoginSocialFacebook
              appId={process.env.REACT_APP_FB_APP_ID || ''}
              onResolve={({ provider, data }: IResolveParams) => {
                console.log(provider);
                console.log(data);
                console.log(data?.accessToken);
                facebookLogin(data?.accessToken, data?.userID, data?.email);
              }}
              onReject={(err) => {
                console.log(err);
              }}
            >
              <button className="btn-social__facebook full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faFacebook as IconProp} className="text color-light" />
                </div>
                facebook
              </button>
            </LoginSocialFacebook>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-3">
            <div className="row">
              <div className="col-12 text-center">
                <h1 className="sub-title color-dark mt-7 mb-3">Not already a member?</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-3 col-lg-3 mb-5 mt-4">
            <button onClick={() => navigate('/signup')} className=" btn-dark-blue full rounded ">
              Signup
            </button>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-4">
            <div className="row">
              <div className="col-12  text-center">
                <h1 className="sub-title color-dark mt-7 mb-3">Forgot your password?</h1>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={form2.handleSubmit(resetPassword)}>
          <div className="row justify-content-center">
            <div className="row justify-content-center mt-4">
              <div className="col-12 col-md-4 col-lg-3">
                <FormField name='email' label="Username or E-mail" fullWidth required error={form2.formState.errors.email}>
                  <input id="email" type="email" placeholder="E-mail address" className="text-center" {...form2.register('email', { required: 'Please type your email' })} />
                </FormField>
              </div>
            </div>
            <div className="col-12 col-md-3 col-lg-3 my-4">
              <button type="submit" className="btn-blue full rounded 3">
                Reset password
              </button>
            </div>
            {sentReset && (
              <>
                <div className="row justify-content-center mt-3">
                  <div className="col-12 col-md-4 col-lg-3 my-3 ">
                    Please check your email to get the new password, if you don’t receive any email within a few hours, please write to{' '}
                    <a href="info@desall.com">info@desall.com</a>
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </main>

      <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
    </>
  );
};

export default LoginPage;
